<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Destinations
        <small>List of destinations</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Destinations</li>
      </ol>
    </section>

    <section class="content">
      <div class="button-flagging">
        <a v-if="this.$route.query.type === 'domestic'" 
          class="btn active-flag disabled"
          disabled>
          Domestic Destinations
        </a>
        <a v-else class="btn btn-primary"
          @click.prevent="changeFlag()">
          Domestic Destination
        </a>
        <a v-if="this.$route.query.type === 'international'" 
          class="btn active-flag disabled"
          disabled>
          International Destination
        </a>
        <a v-else class="btn btn-primary"
          @click.prevent="changeFlag()">
          International Destination
        </a>
      </div>

      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Destinations</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="row">
            <div v-if="params.type === 'domestic'" class="col-12 col-sm-6">
              <div class="form-group">
                <label for="vendor">
                  Province
                </label>
                <v-select 
                  class="style-chooser" 
                  placeholder="Select All" 
                  @input="onSelect"
                  v-model="params.province" 
                  :options="list.provinces" 
                  id="vendor">
                </v-select>
              </div>
            </div>

            <div v-else class="col-12 col-sm-6">
              <div class="form-group">
                <label for="vendor">
                  Country
                </label>
                <v-select 
                  class="style-chooser" 
                  placeholder="Select All"
                  @input="onSelectCountry" 
                  v-model="params.country" 
                  :options="list.countries" 
                  id="vendor">
                </v-select>
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="vendor">
                  City
                </label>
                <v-select class="style-chooser" placeholder="Select City" v-model="params.city" id="vendor" :options="list.cities">
                </v-select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="box-header">
              <a class="btn btn-success pull-right"
                @click.prevent="search">
                Search
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Destination
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th class="text-center">Image</th>
                <th>Slug</th>
                <th>Parent</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody v-if="!destinations" key="empty">
              <template>
                <tr>
                  <td colspan="4">
                    Result not found
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <template v-for="parent in destinations">
                <template v-if="parent.child" v-for="child in parent.child">
                  <tr :key="child.id">
                    <td>{{ child.name }}</td>
                    <td>{{ child.region_type }}</td>
                    <td class="text-center">
                      <img
                        v-if="child.image_url && child.image_url != ''"
                        :src="parseImage(child.image_url, '_thumb')"
                        style="width: 32px" />
                    </td>
                    <td>{{ child.slug }}</td>
                    <td>{{ child.parent_name }}</td>
                    <td>
                      <a class="btn btn-primary btn-xs" @click.prevent="edit(child.id)">Edit</a>
                      <a class="btn btn-danger btn-xs" @click.prevent="remove(child)">Delete</a>
                      <a class="btn btn-primary btn-xs" @click.prevent="view(child.id)">View</a>
                      <div v-if="error" class="alert alert-danger">
                        <a class="close"
                          @click="error = false">
                          &times;
                        </a>
                        {{ error }}
                      </div>
                    </td>
                  </tr>
                  <template v-if="child.child" v-for="grandchild in child.child">
                    <tr :key="grandchild.id">
                      <td>{{ grandchild.name }}</td>
                      <td>{{ grandchild.region_type }}</td>
                      <td class="text-center">
                        <img
                          v-if="grandchild.image_url && grandchild.image_url != ''"
                          :src="parseImage(grandchild.image_url, '_thumb')"
                          style="width: 32px" />
                      </td>
                      <td>{{ grandchild.slug }}</td>
                      <td>{{ grandchild.parent_name }}</td>
                      <td>
                        <a class="btn btn-primary btn-xs" @click.prevent="edit(grandchild.id)">Edit</a>
                        <a class="btn btn-danger btn-xs" @click.prevent="remove(grandchild)">Delete</a>
                        <a class="btn btn-primary btn-xs" @click.prevent="view(grandchild.id)">View</a>
                        <div v-if="error" class="alert alert-danger">
                          <a class="close"
                            @click="error = false">
                            &times;
                          </a>
                          {{ error }}
                        </div>
                      </td>
                    </tr>
                    <template v-if="grandchild.child" v-for="grandgrandchild in grandchild.child">
                      <tr :key="grandgrandchild.id">
                        <td>{{ grandgrandchild.name }}</td>
                        <td>{{ grandgrandchild.region_type }}</td>
                        <td class="text-center">
                          <img
                            v-if="grandgrandchild.image_url && grandgrandchild.image_url != ''"
                            :src="parseImage(grandgrandchild.image_url, '_thumb')"
                            style="width: 32px" />
                        </td>
                        <td>{{ grandgrandchild.slug }}</td>
                        <td>{{ grandgrandchild.parent_name }}</td>
                        <td>
                          <a class="btn btn-primary btn-xs" @click.prevent="edit(grandgrandchild.id)">Edit</a>
                          <a class="btn btn-danger btn-xs" @click.prevent="remove(grandgrandchild)">Delete</a>
                          <a class="btn btn-primary btn-xs" @click.prevent="view(grandgrandchild.id)">View</a>
                          <div v-if="error" class="alert alert-danger">
                            <a class="close"
                              @click="error = false">
                              &times;
                            </a>
                            {{ error }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';

export default {
  name: 'DestinationIndex',

  mixins: [Common],

  data() {
    return {
      destinations: [],
      error: null,

      params: {
        type: this.$route.query.type,
        province: null,
        city: null,
        country: null,
      },
      list: {
        provinces: [],
        cities: [],
        countries: [],
      },
    };
  },

  methods: {
    fetch() {
      this.axios.get('/destinations?perpage=500', {
          params: this.params,
        })
        .then((response) => {
          this.destinations = response.data.data;
        });
    },
    search() {
      if (this.params.city) {
        this.axios.get(`/destinations?type=${this.$route.query.type}&name=${this.params.city.label}`)
        .then((response) => {
          this.destinations = response.data.data;
        });
      } else if (this.params.type === 'domestic' && this.params.province && !this.params.city) {
        this.axios.get(`/destinations?type=domestic&name=${this.params.province.label}`)
        .then((response) => {
          this.destinations = response.data.data;
        });
      } else if (this.params.type === 'international' && this.params.country && !this.params.city) {
        this.axios.get(`/destinations?type=international&name=${this.params.country.label}`)
        .then((response) => {
          this.destinations = response.data.data;
        });
      } else {
        this.fetch();
      }
    },
    fetchProvince() {
      if (this.params.type === 'domestic') {
        this.axios.get('/destinations?perpage=50&type=domestic&region_type=province')
        .then((response) => {
          const provinceData = response.data.data[0].child[0].child;
          this.list.provinces = provinceData ? provinceData.map(item => (
            { label: item.name, value: item.id })) : [];
        });
      } else {
        this.axios.get('/destinations?perpage=50&type=international&region_type=country')
        .then((response) => {
          const countryData = response.data.data[0].child;
          this.list.countries = countryData ? countryData.map(item => (
            { label: item.name, value: item.id })) : [];
        });
      }
    },
    fetchCity() {
      if (this.params.type === 'domestic') {
        if (this.params.province !== null) {
          this.axios.get(`/destinations/${this.params.province.value}`)
          .then((response) => {
            const cityData = response.data.data.child;
            console.log(cityData);
            this.list.cities = cityData ? cityData.map(item => ({ 
              label: item.name, value: item.id })) : [];
          });
        } else {
           this.axios.get('/destinations?type=domestic&region_type=country')
          .then((response) => {
            const cityData = response.data.data[0].child[0].child;
            const cityAll = cityData.flatMap(item => item.child).filter(item => item !== null);
            this.list.cities = cityAll ? cityAll.map(item => (item !== null ? { 
              label: item.name, value: item.id } : {})) : [];
          });
        }
      } 
      if (this.params.type === 'international') {
        if (this.params.country !== null) {
          this.axios.get(`/destinations/${this.params.country.value}`)
          .then((response) => {
              const cityData = response.data.data.child;
              this.list.cities = cityData ? cityData.map(item => ({ 
                label: item.name, value: item.id })) : [];
            });
        } else {
          this.axios.get('/destinations?type=international&region_type=country')
          .then((response) => {
              const cityAll = response.data.data[0].child;
              const cityData = cityAll.flatMap(item => item.child).filter(item => item !== null);
              console.log(cityData);
              this.list.cities = cityData ? cityData.map(item => (item !== null ? { 
                label: item.name, value: item.id } : {})) : [];
            });
        }
      }
    },
    setParamsToDefault() {
      this.params.city = null;
      this.params.province = null;
      this.params.country = null;
    },
    onSelect() {
      this.params.city = null;
      if (!this.params.province) {
          this.params.city = null;
          this.fetch();
      } else {
        this.fetchCity();
      }
      if (this.params.province === null) {
        this.fetchCity();
      }
    },
    onSelectCountry() {
      this.params.city = null;
      if (!this.params.country) {
          this.params.city = null;
          this.fetch();
      } else {
        this.fetchCity();
      }
      if (this.params.country === null) {
        this.fetchCity();
      }
    },
    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    showDeleteButton(slug) {
      if (
        slug === 'internasional' ||
        slug === 'international' ||
        slug === 'domestik' ||
        slug === 'domestic'
      ) {
        return false;
      }

      return true;
    },
    changeFlag() {
      if (this.params.type === 'domestic') {
        this.params.type = 'international';
      } else {
        this.params.type = 'domestic';
      }
      this.$router.push(`?type=${this.params.type}`);
      this.setParamsToDefault();
      this.fetchProvince();
      this.fetch();
      this.fetchCity();
    },
    add() {
      this.$router.push({
        name: 'destination-create',
        query: {
          types: this.$route.query.type,
        },
      });
    },

    edit(id) {
      this.$router.push({
        name: 'destination-edit',
        params: {
          id,
        },
        query: {
          types: this.$route.query.type,
        },
      });
    },
    view(id) {
      this.$router.push({
        name: 'destination-view',
        params: {
          id,
        },
        query: {
          types: this.$route.query.type,
        },
      });
    },

    delete(destination) {
      this.axios.delete(`/destinations/${destination.id}`)
        .then(() => {
          this.fetch();

          this.$swal(
            'Deleted!',
            `${destination.name} has been deleted.`,
            'success',
          );
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: `Oppss! You can't delete "${destination.name}" because this destination still used by the product`,
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    remove(destination) {
      this.$swal({
        title: 'Deleting Destination',
        text: `Are you sure you want to delete ${destination.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.value) {
          this.delete(destination);
        } else {
          this.$swal(
            'Cancelled',
            null,
            'info',
          );
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal(
            'Cancelled',
            null,
            'info',
          );
        }
      });
    },
  },

  created() {
    this.fetch();
    this.fetchProvince();
    this.fetchCity();
  },
};
</script>

<style scoped>
  .strong {
    font-weight: bold;
  }

  .child-level-1,
  .child-level-2,
  .child-level-3 {
    background: transparent url('../../../assets/img/arrow-right.svg') top 1.125rem left 0.5rem no-repeat;
    background-size: 1em;
  }

  .child-level-1 {
    padding-left: 2.5rem;
  }

  .child-level-2 {
    background-position: top 1.125rem left 2.25rem;
    padding-left: 4rem;
  }

  .child-level-3 {
    background-position: top 1.125rem left 4rem;
    padding-left: 5.5rem;
  }
</style>
<style>
.style-chooser .vs__dropdown-menu {
  max-height: 100px;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/destinations/Index.vue